import { Pencil, Trash2 } from 'lucide-react';
import React, { useState } from 'react';
import { visiteAPI } from '../../services/api';
import MappaFiller from './MappaFiller';
import { notificaErrore, messaggioDa } from '../../utils/notifiche';

const ModuloFiller = ({ modulo, visitaId, onUpdate }) => {
    const [editing, setEditing] = useState(false);
    const [contenuto, setContenuto] = useState(modulo.contenuto || { valori: {}, zones: [] });

    const handleSave = async () => {
        try {
            await visiteAPI.updateModulo(modulo.id, { titolo: modulo.titolo, contenuto, ordine: modulo.ordine });
            setEditing(false);
            onUpdate();
        } catch (error) { notificaErrore(messaggioDa(error, 'Non riesco a salvare lo schema filler')); }
    };

    const handleDelete = async () => {
        if (window.confirm('Eliminare la mappa Filler?')) {
            try {
                await visiteAPI.deleteModulo(modulo.id);
                onUpdate();
            } catch (error) { notificaErrore(messaggioDa(error, 'Non riesco a eliminare lo schema filler')); }
        }
    };

    return (
        <div className="modulo-card modulo-filler">
            <div className="modulo-header">
                <h3>{modulo.titolo}</h3>
                <div className="modulo-actions">
                    {editing ? (
                        <>
                            <button onClick={handleSave} className="btn-save">Salva</button>
                            <button onClick={() => setEditing(false)} className="btn-cancel">✕</button>
                        </>
                    ) : (
                        <>
                            <button onClick={() => setEditing(true)} className="btn-edit-small"><Pencil size={15} strokeWidth={1.8} aria-hidden="true" /></button>
                            <button onClick={handleDelete} className="btn-delete-small"><Trash2 size={15} strokeWidth={1.8} aria-hidden="true" /></button>
                        </>
                    )}
                </div>
            </div>
            <div className="modulo-content">
                <MappaFiller
                    data={contenuto}
                    onChange={setContenuto}
                    readOnly={!editing}
                />
            </div>
        </div>
    );
};

export default ModuloFiller;
